import {
  getBannersStart,
  getBannersSuccess,
  getBannersFailure,
  createBannerStart,
  createBannerSuccess,
  createBannerFailure,
  updateBannerStart,
  updateBannerSuccess,
  updateBannerFailure,
  deleteBannerStart,
  deleteBannerSuccess,
  deleteBannerFailure,
  getWebBannersStart,
  getWebBannersSuccess,
  getWebBannersFailure,
  createWebBannerStart,
  createWebBannerSuccess,
  createWebBannerFailure,
  updateWebBannerStart,
  updateWebBannerSuccess,
  updateWebBannerFailure,
  deleteWebBannerStart,
  deleteWebBannerSuccess,
  deleteWebBannerFailure,
  getTitlesStart,
  getTitlesSuccess,
  getTitlesFailure,
  updateTitlesStart,
  updateTitlesSuccess,
  updateTitlesFailure,
  getContactsStart,
  getContactsSuccess,
  getContactsFailure,
} from "./contentSlice";
import {
  createBanner,
  getAllBanners,
  updateBanner,
  deleteBanner,
  createWebBanner,
  getAllWebBanners,
  updateWebBanner,
  deleteWebBanner,
  getTitle,
  updateTitle,
  contactDetails,
} from "services/contentService";

// fetch contacts
export const fetchContacts = () => async (dispatch) => {
  try {
    dispatch(getContactsStart());
    const response = await contactDetails();
    dispatch(getContactsSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getContactsFailure(error.message));
    throw error;
  }
};

// Banner Actions
export const fetchBanners = () => async (dispatch) => {
  try {
    dispatch(getBannersStart());
    const response = await getAllBanners();
    dispatch(getBannersSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getBannersFailure(error.message));
    throw error;
  }
};

export const addBanner = (formData) => async (dispatch) => {
  try {
    dispatch(createBannerStart());
    const response = await createBanner(formData);
    dispatch(createBannerSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(createBannerFailure(error.message));
    throw error;
  }
};

export const modifyBanner = (id, data) => async (dispatch) => {
  try {
    dispatch(updateBannerStart());
    const response = await updateBanner(id, data);
    dispatch(updateBannerSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(updateBannerFailure(error.message));
    throw error;
  }
};

export const removeBanner = (id) => async (dispatch) => {
  try {
    dispatch(deleteBannerStart());
    const response = await deleteBanner(id);
    dispatch(deleteBannerSuccess(id));
    return response;
  } catch (error) {
    dispatch(deleteBannerFailure(error.message));
    throw error;
  }
};

// Banner Actions
export const fetchWebBanners = () => async (dispatch) => {
  try {
    dispatch(getWebBannersStart());
    const response = await getAllWebBanners();
    dispatch(getWebBannersSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getWebBannersFailure(error.message));
    throw error;
  }
};

export const addWebBanner = (formData) => async (dispatch) => {
  try {
    dispatch(createWebBannerStart());
    const response = await createWebBanner(formData);
    dispatch(createWebBannerSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(createWebBannerFailure(error.message));
    throw error;
  }
};

export const modifyWebBanner = (id, data) => async (dispatch) => {
  try {
    dispatch(updateWebBannerStart());
    const response = await updateWebBanner(id, data);
    dispatch(updateWebBannerSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(updateWebBannerFailure(error.message));
    throw error;
  }
};

export const removeWebBanner = (id) => async (dispatch) => {
  try {
    dispatch(deleteWebBannerStart());
    const response = await deleteWebBanner(id);
    dispatch(deleteWebBannerSuccess(id));
    return response;
  } catch (error) {
    dispatch(deleteWebBannerFailure(error.message));
    throw error;
  }
};

// Title Actions
export const fetchTitles = () => async (dispatch) => {
  try {
    dispatch(getTitlesStart());
    const response = await getTitle();
    dispatch(getTitlesSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getTitlesFailure(error.message));
    throw error;
  }
};

export const updateTitleData = (data) => async (dispatch) => {
  try {
    dispatch(updateTitlesStart());
    const response = await updateTitle(data);
    dispatch(updateTitlesSuccess(data));
    return response;
  } catch (error) {
    dispatch(updateTitlesFailure(error.message));
    throw error;
  }
};
